module.exports = "/images/vendor/flag-icon-css/flags/4x3/gi.svg?dce455a731d707ad9f6f4d4b60bb78fa";